export const shareListing = async ({ title, path }) => {
  if (typeof window === 'undefined') return false;

  const shareUrl = `${window.location.origin}${path}`;
  const sharePayload = { title, text: title, url: shareUrl };

  if (navigator.share) {
    try {
      await navigator.share(sharePayload);
      return true;
    } catch (error) {
      if (error?.name !== 'AbortError') {
        console.error('Share failed:', error);
      }
    }
  }

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(shareUrl);
      return true;
    } catch (error) {
      console.error('Copy link failed:', error);
    }
  }

  return false;
};
